import {Model} from '@vuex-orm/core'

export default class LtmHasRoomtypeAt extends Model {
  static entity = 'ltmHasRoomtypesAt'

  static fields() {
    return {
      ltms_id: this.number(null),
      roomtypes_id: this.number(null),
    }
  }
}
